import { useCallback, useEffect, useRef } from "react";

const FOCUSABLE_SELECTOR =
  'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';

export function useScreenNavigation(
  formTitle: string,
  footerBtnOnClick: () => void,
  footerBtnDisabled: boolean,
  footerBtnLoading: boolean
) {
  const onClickRef = useRef(footerBtnOnClick);
  onClickRef.current = footerBtnOnClick;

  // scroll to top on screen change
  useEffect(() => {
    document.getElementById("main")?.scrollTo({ top: 0, behavior: "smooth" });
    window.scrollTo({ top: 0 });
  }, [formTitle]);

  //tab to focus each screen's first input field
  useEffect(() => {
    const timer = setTimeout(() => {
      const focusable = document
        .getElementById("main")
        ?.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);
      focusable?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, [formTitle]);

  // enter key to action continue or submit button
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key !== "Enter") return;
      const tag = (e.target as HTMLElement).tagName;
      if (tag === "TEXTAREA" || tag === "BUTTON") return;
      if (footerBtnDisabled || footerBtnLoading) return;
      e.preventDefault();
      onClickRef.current();
    },
    [footerBtnDisabled, footerBtnLoading]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);
}
